import { createBrowserRouter } from 'react-router-dom';
import loadable from '@loadable/component';

import Layout from '../components/module/Layout';
import PreRenderedLoadable from './_PreRenderedLoadable';
import ErrorBoundary from '../components/module/ErrorBoundary';

const Creator = loadable(() => import('../pages/creator'));
const Web3 = loadable(() => import('../pages/Web3'));
const Worlds = loadable(() => import('../pages/Worlds'));
const Home = loadable(() => import('../pages/home'));
const Faq = loadable(() => import('../pages/faq'));
const Download = loadable(() => import('../pages/Download'));
const DigitalGuidelines = loadable(() => import('../pages/digitalGuidelines'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'creator',
        element: <PreRenderedLoadable loadableComp={Creator} />,
      },
      {
        path: 'web3',
        element: <PreRenderedLoadable loadableComp={Web3} />,
      },
      {
        path: 'worlds',
        element: <PreRenderedLoadable loadableComp={Worlds} />,
      },
      {
        path: 'faq',
        element: <PreRenderedLoadable loadableComp={Faq} />,
      },
      {
        path: 'download',
        element: <PreRenderedLoadable loadableComp={Download} />,
      },
      {
        path: 'digital-guidelines',
        element: <PreRenderedLoadable loadableComp={DigitalGuidelines} />,
      },
    ],
  },
]);
